export interface Feature {
  id: number;
  featureName: string;
}

export enum Features
{
  Basic=1,
  Mfa=2,
  Retailers=3,
  Products=4,
  ProductCustomisations=5,
  Categories=6,
  Collections=7,
  DistributionChannels=8,
  ProductAttributes=9,
  SerialisationEngine=10,
  Sales=11,
  Warranties=12,
  Repair=13,
  DigitalCards=14,
  Customers=15,
  Sellers=16,
  Shipments=17,
  Inventories=18,
  CardOrdering=19,
  Imports=20,
  Exports=21,
  Dashboards=22,
  MagicList=23,
  BusinessGroups=24,
  RetailerAttributes=25,
  DigitalPassport=26
}
